export interface NavigationItemProps { 
  path: string; 
  title: string; 
}

const LEFT_NAVIGATION_BUILDER: NavigationItemProps[] = [
  { path: "/brand/crest", title: "Crest" },
  { path: "/brand/colours", title: "Colours" },
  { path: "/brand/typography", title: "Typography" },
  { path: "/brand/graphics", title: "Graphics" },
  { path: "/brand/art-direction", title: "Art Direction" },
  { path: "/brand/tone-of-voice", title: "Tone Of Voice" },
  { path:"/brand/brand-in-action", title: "Brand In Action" },
];

export default LEFT_NAVIGATION_BUILDER;